import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Beatloader from "../../../Common/BeatLoader";
import SkeletonHeroWrap from "../../../Common/skeleton/SkeletonHeroWrap/SkeletonHeroWrap";
import { useDispatch, useSelector } from "react-redux";
import { HiOutlinePresentationChartBar } from "react-icons/hi2";
import { HiOutlineUserGroup } from "react-icons/hi2";
import { HiOutlineMapPin } from "react-icons/hi2";
import { HiOutlineHandThumbUp } from "react-icons/hi2";
import {
  getHomeBannerData,
  getWebsiteManagementData,
} from "../../../Redux/action/MasterAction";
import Aos from "aos";
const host = process.env.REACT_APP_API_SERVER;

const HeroWrap = () => {
  const navigate = useNavigate();
  const handleNavigation = () => {
    const token = localStorage.getItem("student-token");
    if (token) {
      const decoded = jwtDecode(token);

      if (decoded?.user?.id) {
        navigate("/student/dashboard");
      } else {
        navigate("/login", { state: { user: "student" } });
      }
    } else {
      navigate("/login", { state: { user: "student" } });
    }
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getHomeBannerData());
  }, []);

  const {
    loadingHomeBannerDataApi,
    HomeBannerDataApiData,
    HomeBannerDataApiError,
  } = useSelector((state) => state?.MasterReducer);

  useEffect(function () {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <>
      {loadingHomeBannerDataApi ? (
        <SkeletonHeroWrap />
      ) : (
        <section className="hero-wrap style1 hero-bgg">
          <div className="container">
            {/* {loadingWebsiteManagementDataListApi ?
                    <Beatloader />
                    : */}
            <div className="row align-items-center" data-aos="fade-up">
              <div className="col-lg-7 col-md-8">
                <div className="home-slide-face">
                  <div className="home-slide-text ">
                    <h1>{HomeBannerDataApiData?.home_section_one_title}</h1>
                    <p>{HomeBannerDataApiData?.home_section_one_subtitle}</p>
                  </div>
                  <div className="banner-five-btns">
                    <a onClick={handleNavigation}>
                      <button className="btn btn-primary">Get Started</button>
                    </a>
                  </div>
                  {/* <div className="search-box">
                                <form action="">
                                    <div className="form-group search-info location-search">
                                        <input
                                            type="text"
                                            className="form-control text-truncate"
                                            placeholder="Find the Perfect Mentors near your location"
                                        />
                                        <a
                                            href=""
                                            className="btn bg-search search-btn align-items-center d-flex justify-content-center"
                                            style={{ backgroundColor: "#0b5ed7" }}
                                        >
                                            <img
                                                src="https://mentoring.dreamstechnologies.com/html/template/assets/img/icon/search-white-icon.svg"
                                                alt=""
                                            />
                                        </a>
                                    </div>
                                </form>
                            </div> */}
                  <div className="pop-search"></div>
                </div>
              </div>

              <div className="col-lg-5 d-flex align-items-end">
                <div className="girl-slide-img">
                  <img
                    src={`${host}${HomeBannerDataApiData?.home_section_one_image}`}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div>


              
              {/* <div className="col-lg-2">
                        <div className="banner-six-counter">
                            <div className="counter-box">
                                <h5>
                                    <span className="counterUp">{HomeBannerDataApiData?.home_section_one_counter_one_count}</span>+
                                </h5>
                                <h4>{HomeBannerDataApiData?.home_section_one_counter_one_name}</h4>
                            </div>
                            <div className="counter-box">
                                <h5>
                                    <span className="counterUp">{HomeBannerDataApiData?.home_section_one_counter_two_count}</span>+
                                </h5>
                                <h4>{HomeBannerDataApiData?.home_section_one_counter_two_name}</h4>
                            </div>
                            <div className="counter-box">
                                <h5>
                                    <span className="counterUp">{HomeBannerDataApiData?.home_section_one_counter_three_count}</span>+
                                </h5>
                                <h4>{HomeBannerDataApiData?.home_section_one_counter_three_name}</h4>
                            </div>
                        </div>
                    </div> */}
              {/* <div className="col-lg-2">
                <div className="banner-six-counter">
                  {HomeBannerDataApiData?.home_section_one_counter_one_count >
                    0 && (
                    <div className="counter-box">
                      <h5>
                        <span className="counterUp">
                          {
                            HomeBannerDataApiData.home_section_one_counter_one_count
                          }
                        </span>
                        +
                      </h5>
                      <h4>
                        {
                          HomeBannerDataApiData.home_section_one_counter_one_name
                        }
                      </h4>
                    </div>
                  )}

                  {HomeBannerDataApiData?.home_section_one_counter_two_count >
                    0 && (
                    <div className="counter-box">
                      <h5>
                        <span className="counterUp">
                          {
                            HomeBannerDataApiData.home_section_one_counter_two_count
                          }
                        </span>
                        +
                      </h5>
                      <h4>
                        {
                          HomeBannerDataApiData.home_section_one_counter_two_name
                        }
                      </h4>
                    </div>
                  )}

                  {HomeBannerDataApiData?.home_section_one_counter_three_count >
                    0 && (
                    <div className="counter-box">
                      <h5>
                        <span className="counterUp">
                          {
                            HomeBannerDataApiData.home_section_one_counter_three_count
                          }
                        </span>
                        +
                      </h5>
                      <h4>
                        {
                          HomeBannerDataApiData.home_section_one_counter_three_name
                        }
                      </h4>
                    </div>
                  )}
                </div>
              </div> */}
            </div>

           

            {/* } */}
          </div>
        </section>

        

        
      )}
    </>
  );
};

export default HeroWrap;
